import StorageService from '@/utils/storage-service';
const storage = StorageService.getStorage();

export const IS_MARKET_PLACE_EXACT_MATCH = 'isMarketplaceExactMatch';
export const MARKETPLACE_FILTER_BY_FEATURE_TYPE = 'marketplaceFilterByFeatureType';

export const initialState = () => ({
	marketplace: null,
	isMarketplaceExactMatch: StorageService.getStorageValueWithFallback(storage, IS_MARKET_PLACE_EXACT_MATCH, true),
	marketplaceFilterByFeatureType: storage.getItem(MARKETPLACE_FILTER_BY_FEATURE_TYPE) || 'everything',
});

const state = initialState();

export default state;
